import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from "array-move";
import PropTypes from "prop-types";

import { strCode } from "../../consts";
import { t } from "../../services";
import SVG from "../SVG/icons";
import IconButton from "../Buttons/IconButton";
import FlexContainers from "../Containers/FlexContainers";
import { AddButtonContainer, PageItem, PagesWrapper } from "./styled";

const PageSelector = ({
  pages,
  activePage,
  errorPages = [],
  isReordable,
  setActivePage = () => {},
  onAddNewPage,
  setPages = () => {},
  component
}) => {
  const onSortEnd = (oldIndex, newIndex) => {
    if (setPages) {
      const reorderedPages = arrayMoveImmutable(pages, oldIndex, newIndex);
      setPages(reorderedPages);
    }
  };

  const getPageItem = (page) => {
    return (
      <PageItem
        id={page.id}
        className="test"
        key={page.id}
        onClick={() => setActivePage(page.id)}
        isActive={activePage === page.id}
        hasError={errorPages?.includes(page.id)}
        disabled={page?.disabled}>
        {t(page.title)}

        {component && component(page)}
      </PageItem>
    );
  };

  return (
    <PagesWrapper>
      <SortableList
        onSortEnd={onSortEnd}
        className="page-item-list"
        draggedItemClassName="dragged-page"
        lockAxis="x">
        {pages?.map((page) => {
          return isReordable ? (
            <SortableItem key={page.id}>{getPageItem(page)}</SortableItem>
          ) : (
            getPageItem(page)
          );
        })}
      </SortableList>

      {onAddNewPage && (
        <AddButtonContainer Container={FlexContainers.FlexColumnCenter} width={48}>
          <IconButton onClick={onAddNewPage} tooltipLabel={t(strCode.ADD_NEW_ITEM_TOOLTIP)}>
            <SVG.AddIcon />
          </IconButton>
        </AddButtonContainer>
      )}
    </PagesWrapper>
  );
};

PageSelector.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      disabled: PropTypes.bool
    }).isRequired
  ),
  activePage: PropTypes.string,
  errorPages: PropTypes.arrayOf(PropTypes.string),
  isReordable: PropTypes.bool,
  setActivePage: PropTypes.func.isRequired,
  onAddNewPage: PropTypes.func,
  setPages: PropTypes.func,
  component: PropTypes.func
};

export default PageSelector;
